import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { LuCalendarDays, LuArrowRight, LuUser } from "react-icons/lu";
import utils from '../../utils';

function BlogItem({ post }) {
    if (!post) return null;

    return (
        <article className="bg-white rounded-2xl overflow-hidden shadow-[0_20px_40px_-15px_rgba(26,42,74,0.05)] border border-outline-variant/30 group flex flex-col h-full transition-all duration-500 hover:shadow-xl hover:border-primary/20">
            <div className="aspect-video w-full overflow-hidden">
                <Link to={`/blog/${post.slug}`}>
                    <img
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                        src={post.image}
                        alt={post.name}
                    />
                </Link>
            </div>

            <div className="p-8 flex flex-col flex-grow">
                <div className="flex items-center gap-6 text-[10px] font-black uppercase tracking-widest text-on-surface-variant mb-4">
                    <span className="flex items-center gap-2">
                        <LuCalendarDays className="text-primary" size={14} />
                        {moment(post.creation_time).format('MMM DD, YYYY')}
                    </span>
                    <span className="flex items-center gap-2">
                        <LuUser className="text-primary" size={14} />
                        {utils.createProfileLetter(post.owner) || 'Admin'}
                    </span>
                </div>

                <Link to={`/blog/${post.slug}`}>
                    <h2 className="text-2xl font-headline font-black text-on-surface mb-4 group-hover:text-primary transition-colors line-clamp-2 leading-tight">
                        {post.name}
                    </h2>
                </Link>

                <div
                    className="text-on-surface-variant leading-relaxed mb-8 flex-grow line-clamp-3 text-sm"
                    dangerouslySetInnerHTML={{ __html: post.text }}
                />

                <Link
                    className="inline-flex items-center gap-2 text-primary font-black text-xs uppercase tracking-widest hover:gap-4 transition-all duration-300 mt-auto"
                    to={`/blog/${post.slug}`}
                >
                    Read Full Insight <LuArrowRight size={16} />
                </Link>
            </div>
        </article>
    );
}

export default BlogItem;